import {useState} from 'react';
import {Card} from 'react-bootstrap';
import {useIntl} from 'react-intl';
import TabComponent from '../../../../common/components/TabComponent';
import RedirectionModal from '../../../../common/components/modal/RedirectionModal';
import {useRedirectionModal} from '../../../../common/components/modal/hooks/useRedirectionModal';
import {getEncryptedURIV1} from '../../../../common/components/ECV1Link';
import {useClientLogin} from '../../../../hooks/useClientLogin';
import Level3Title from '../../../../common/components/title/Level3Title';
import TechnicalInfo from './TechnicalInfo';
import OutilsTest from '../../../../../Domains/Service/Components/Connexion/OutilsTest';

interface RedirectCardProps {
  title: string;
  description: string;
  buttonLabel: string;
  url: string;
  onRedirect: (url: string) => void;
}

const RedirectCard = ({title, description, buttonLabel, url, onRedirect}: RedirectCardProps): JSX.Element => (
  <div className="row g-4 mt-1">
    <div className="col-12 col-xxl-6">
      <Card>
        <Card.Header>
          <Card.Title>
            <Level3Title title={title} />
          </Card.Title>
        </Card.Header>
        <Card.Body>
          <p>{description}</p>
          <button className="btn btn-primary" onClick={() => onRedirect(url)}>
            {buttonLabel}
          </button>
        </Card.Body>
      </Card>
    </div>
  </div>
);

const RouteursCis = (): JSX.Element => {
  const intl = useIntl();
  const userLogin = useClientLogin();
  const [activeTab, setActiveTab] = useState('alertes');
  const {isOpen, closeModal, confirmRedirection, handleContinue, pendingUrl, countdown} =
    useRedirectionModal();

  return (
    <>
      <TabComponent
        tabData={[
          {
            title: intl.formatMessage({id: 'CONFIGURATION.ALERTES'}),
            key: 'alertes',
            content: (
              <RedirectCard
                title={intl.formatMessage({id: 'CONFIGURATION.ALERTES'})}
                description={intl.formatMessage({id: 'ROUTEURS.ALERTES.DESC'})}
                buttonLabel={intl.formatMessage({id: 'CONFIGURATION.ALERTES'})}
                url={getEncryptedURIV1('/supervision/preferences', userLogin)}
                onRedirect={confirmRedirection}
              />
            ),
          },
          {
            title: intl.formatMessage({id: 'CONFIGURATION.INFO.TECH'}),
            key: 'tech-info',
            content: <TechnicalInfo />,
          },
          {
            title: intl.formatMessage({id: 'CONFIGURATION.INFO.OUTILS.TEST'}),
            key: 'outils-test',
            content: <OutilsTest />,
          },
        ]}
        activeKey={activeTab}
        onTabChange={setActiveTab}
      />
      <RedirectionModal
        show={isOpen}
        onCancel={closeModal}
        onContinue={handleContinue}
        url={pendingUrl || ''}
        countdown={countdown}
      />
    </>
  );
};

export default RouteursCis;
